import type { RacingBetType } from '@mobi/betslip/types'
import { PlanSeq } from '@mobi/api-types'
import { getToteBetType } from './buildBetItem/getToteBetType'

const SUPPORTED_TOTE_BET_TYPES: RacingBetType[] = [
  'Win & Place',
  'Quinella',
  'Exacta',
  'Trifecta',
  'First 4',
  'Double',
  'Quaddie',
]

export const isLoadBetSupported = (planSeq: number): boolean => {
  if (planSeq === PlanSeq.FOBRacing) return true

  if (planSeq === PlanSeq.FOBSports) return true

  const betType = getToteBetType(planSeq)
  if (!betType) return false

  return SUPPORTED_TOTE_BET_TYPES.includes(betType)
}
